export function isWechatBrowser() {
  // if (process.env.NODE_ENV === "development") {
  //   return false;
  // }
  let ua = window.navigator.userAgent.toLowerCase();
  let matchedStr = ua.match(/MicroMessenger/i); // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  return matchedStr && matchedStr[0] === "micromessenger";
}

export const isInWechatMP = () => {
  return (
    (navigator.userAgent.match(/micromessenger/i) &&
      navigator.userAgent.match(/miniprogram/i)) ||
    window.__wxjs_environment === "miniprogram"
  );
};
